<template>
    <div class="InstagramBusinessChannelDemography well flex flex-col justify-between">
        <h3>Alder</h3>

        <div class="flex">
            <div class="w-1/2+labels text-right">
                <span class="small">
                    <strong>{{ channelStat.payload.demography.male.sum }}%</strong> Mænd
                    <span class="GraphDot --light"></span>
                </span>
                <bar-chart
                    class="demo-graph graph-age-m"
                    :colors="['var(--magic-color)']"
                    :library="maleConfig"
                    :data="channelStat.payload.demography.male.data"
                ></bar-chart>
            </div>

            <div class="w-1/2">
                <span class="small">
                    <span class="GraphDot"></span>
                    Kvinder <strong>{{ channelStat.payload.demography.female.sum }}%</strong>
                </span>
                <bar-chart
                    class="demo-graph graph-age-f"
                    :colors="['var(--magic-color)']"
                    :library="femaleConfig"
                    :data="channelStat.payload.demography.female.data"
                ></bar-chart>
            </div>
        </div>

        <!-- Spacer -->
        <div></div>
    </div>
</template>

<style type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.InstagramBusinessChannelDemography {
    .w-1\/2\+labels {
        width: calc(50% + 55px);
    }
    .GraphDot {
        margin: 3px;

        &:after {
            background-color: @brand-primary;
            border-radius: 100%;
            content: '';
            display: inline-block;
            position: relative;
            width: 1.2rem;
            height: 1.2rem;
            top: 0.25rem;
        }

        &.--light:after {
            background-color: @brand-primary-light;
        }
    }
}
</style>

<script type="text/babel">
export default {
    props: ['channelStat'],

    data() {
        return {
            graphBaseConfig: {
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    series: {
                        pointWidth: 25,
                    },
                    bar: {
                        dataLabels: {
                            enabled: true,
                            format: '{y} %',
                            color: '#616161',
                            style: {
                                fontSize: '13px',
                                textOutline: false,
                                fontWeight: 200,
                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                            },
                        },
                    },
                },
                xAxis: {
                    lineWidth: 0,
                    minorGridLineWidth: 0,
                    lineColor: 'transparent',
                    minorTickLength: 0,
                    tickLength: 0,
                    labels: {
                        enabled: false,
                    },
                },
                yAxis: {
                    gridLineWidth: 0,
                    lineColor: 'transparent',
                    lineWidth: 0,
                    minorGridLineWidth: 0,
                    minorTickLength: 0,
                    min: 0,
                    max: 100,
                    tickLength: 0,
                    labels: {
                        enabled: false,
                    },
                },
            },
        }
    },

    computed: {
        femaleConfig() {
            return this.graphBaseConfig
        },

        maleConfig() {
            return {
                ...this.graphBaseConfig,
                xAxis: {
                    ...this.graphBaseConfig.xAxis,
                    lineColor: '#dddddd',
                    lineWidth: 1,
                    labels: {
                        enabled: true,
                    },
                },
                yAxis: {
                    ...this.graphBaseConfig.yAxis,
                    reversed: true,
                },
            }
        },
    },
}
</script>
